import * as React from "react";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { colors } from "./colorsPalettes";
import { Box, Typography } from "@mui/material";

const sizing = {
  margin: { right: 5 },
  width: 400,
  height: 400,
  legend: { hidden: true },
};

export default function Pie({ data }) {
  const TOTAL = data.map((item) => item.value).reduce((a, b) => a + b, 0);

  const getArcLabel = (params) => {
    const percent = params.value / TOTAL;
    return `${(percent * 100).toFixed(0)}%`;
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap">
      <Box>
        <PieChart
          colors={colors}
          series={[
            {
              innerRadius: 120,
              outerRadius: 180,
              arcLabelMinAngle: 35,
              data,
              arcLabel: getArcLabel,
            },
          ]}
          sx={{
            [`& .${pieArcLabelClasses.root}`]: {
              fill: "white",
              fontSize: 14,
            },
          }}
          {...sizing}
        />
      </Box>
      <Box ml={5} mt={2}>
        {data.map((item, index) => (
          <Box key={item.label} display="flex" alignItems="center" mb={1}>
            <Box
              sx={{
                width: 14,
                height: 14,
                backgroundColor: colors[index % colors.length],
                borderRadius: "30%",
                marginRight: 1,
              }}
            />
            <Typography variant="body2" color="text.primary">
              {item.label}: {item.value} ({((item.value / TOTAL) * 100).toFixed(1) + "%"})
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
